<template>
  <div>
    <NuxtLayout name="split">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.TRAVELER" />

      <template #aside>
        <UIcon
          name="EscapadaLogoSmall"
          class="w-12 h-12 mb-6 text-white"
          aria-hidden="true"
        />

        <TTitle
          tag="h2"
          size="2xl"
          color="text-white"
          :bold="true"
          leading="tight"
        >
          {{ t('views.registration-traveler-optin.aside.title') }}
        </TTitle>

        <ul>
          <li
            v-for="(item, index) in asideTexts"
            :key="index"
            class="flex gap-x-2"
          >
            <UIcon
              name="i-heroicons-solid-check-badge"
              class="w-6 text-primary-300 h-6"
            ></UIcon>
            <TText
              tag="h2"
              variant="semibold"
              color="text-white"
              classes="mb-4"
            >
              {{ item }}
            </TText>
          </li>
        </ul>
      </template>

      <AuthRegisterTravelerOptin />
      <SSpacer></SSpacer>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
// Constants
import { CONNECTIF_PAGE_TAGS } from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Composables
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'

const { setHeadInfo } = useHeadInfoComposable()
const breadCrumbMenuStore = useMenuBreadcrumbStore()

breadCrumbMenuStore.setMenuBreadcrumb(
  t('menu.breadcrumb.register-traveler-optin'),
)

definePageMeta({
  layout: false,
  splitImageUrl: '/__nuxt-public/images/registration/split-side.jpeg',
  splitImageAlt: 'views.registration-traveler-optin.pageMeta.splitImageAlt',
})

setHeadInfo({
  title: t('views.registration-traveler-optin.seo.title'),
  images: [
    {
      url: '/__nuxt-public/images/registration/split-side.jpeg',
      alt: t('views.registration-traveler-optin.seo.title'),
    },
  ],
})

const asideTexts: Array<string> = [
  t('views.registration-traveler-optin.aside.text1'),
  t('views.registration-traveler-optin.aside.text2'),
  t('views.registration-traveler-optin.aside.text3'),
]

sendConnectifPage()
</script>
